export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Secure Payment page',
      description: 'We keep your financial information securely encrypted',
      methodErrorTips: 'Sorry, the country you selected is currently not supported. Please select another country and try again.',
      recommendation: 'Recommendation',
      cardNumber: 'Card Number',
      cardName: 'Name on card',
      cvv: 'Security code',
      expiredDate: 'Expiration Date',
      billingInfo: 'Billing information',
      country: 'Country',
      state: 'State',
      firstName: 'First name',
      lastName: 'Last name',
      document: 'Document',
      city: 'City',
      address: 'Address',
      streetNumber: 'Street number',
      zipCode: 'Postcode',
      email: 'Email',
      phone: 'Phone number',
      pay: 'PAY',
      choosePaymentMethod: 'Choose payment method',
      continue: 'Continue',
      later: 'Later',
      returnToMerchant: 'Cancel and Return to Merchant',
      resultToMerchant: 'Return to merchant',
      orderId: 'Order ID',
      orderAmount: 'Order Amount',
      billingDescriptor: 'Billing Descriptor',
      goodsName: 'Goods name',
      timeLimit: 'Please complete payment within the time limit,otherwise the page will be timeout',
      otherPaymentMethods: 'Other payment methods',
      close: 'Close',
      paymentErrorTitle: 'Payment failed',
      paymentErrorTip: 'Your payment was not successfully processed.Please try again.',
      paymentFailed: 'Payment process has failed',
      continueShopping: 'Continue Shopping',
      paymentSuccess: 'Payment Process is done successfully',
      paymentPending: 'Payment sent, confirming',
      correctDateTip: 'Please enter a valid expiration date',
      correctCardNumberTip: 'Please enter a valid card number',
      correctSecurityCodeTip: 'Please enter a valid security code',
      mobileMoneyOperator: 'Mobile Money Operator',
      bank: 'Bank',
      correctEmailAddressTip: 'Please enter a valid email address',
      notSupportPaymentTip: 'The current environment does not support {type} payment',
      addValidPaymentCard: 'Please add a valid payment card',
      timeLimitTip: 'A charge will be made 12 hours before the <span class="date">{date}</span>, and then every <span class="date">{month}</span> months for <span class="amount"> {amount} {currency}</span>, you can cancel at any time',
      product: 'Product/Service',
      subscribeType: 'Subscription Type',
      renewCycle: 'Renewal Cycle',
      renewAmount: 'Renewal Amount',
      subscribePay: 'Subscribe and Pay',
      readAgreement: "Read and agree to <span class='protocol-link' style='color: #31a7da;'>《Auto-Renewal Agreement》</span>",
      depict: 'Description',
      copyQrCode: 'Copy QR-Code',
      copySuccess: 'QR-Code copied successfully',
      copyError: 'QR-Code copy failed',
      refreshQrCode: 'Refresh QR-Code'
    },
    subscribe: {
      yourSubscribe: 'Your Subscription',
      unsubscribeTip: 'To cancel, please click the [Unsubscribe] button at the bottom of the page.',
      renewTip: 'Charge <span class="amount"> {amount} {currency}</span> on <span class="date">{date}</span>, can be cancelled at any time',
      unsubscribe: 'Unsubscribe',
      autoRenew: 'Auto-Renewal Agreement',
      unsubscribeTipTwo: 'If you cancel now, you can still use this subscription until <span class="date">{date}</span>.',
      emailVerifyTip: 'Email Verification',
      inputCodeTip: 'Please enter the verification code',
      sendSuccessTip: 'Verification code sent successfully',
      sendErrorTip: 'Failed to send verification code',
      unsubscribeSuccessTip: 'Unsubscribe successfully',
      unsubscribeErrorTip: 'Failed to unsubscribe',
      sendCodeTip: 'Resend in {code} seconds',
      sendEmailTip: 'Get Verification Code',
      daily: 'Every day',
      weekly: 'Every 7 days',
      monthly: 'Every 30 days',
      quarterly: 'Every 90 days',
      semiAnnually: 'Every 180 days',
      annually: 'Every 365 days',
      regularRenewal: 'Regular Renewal',
      oneTime: 'One-Time',
      inputNumberTip: 'Please enter numbers',
      eachCalendarMonth: 'Per Calendar Month'
    },
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      uploadImgErrorTip: 'Only allow uploading files in image format',
      inputMessageTip: 'Please fill in the content',
      sendSuccessTip: 'Successfully sent',
      sendErrorTip: 'Fail in send',
      inputPlaceholder: 'please enter {field}',
      selectPlaceholder: 'please select {field}',
      correctFormat: 'Please enter the correct format, for example: {example}'
    }
  }
}
